import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import 'react-vis/dist/style.css';
import {
  FlexibleWidthXYPlot,
  XYPlot,
  XAxis,
  YAxis,
  VerticalGridLines,
  HorizontalGridLines,
  AreaSeries,
  LineSeries,
  VerticalBarSeries,
  Crosshair
} from 'react-vis';

import Swal from 'sweetalert2'

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';

import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { Container } from 'react-smooth-dnd';
import BeatLoader from 'react-spinners/BeatLoader';

import { toast } from 'react-toastify';
import { colors, toastTimerValue } from '../../../../Shared/utils';

import { decodeHTMLEntities, compareVersionStrings } from '../../../../Functions/utils';

// import { diag_code_ids } from "../../../Shared/diagcode"
import { getLocationStatistics } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';

import { getPreciseTime } from '../../../../Functions/utils';
import PeriodSelect from '../../Sidebar/PeriodSelect';

import './StatisticsDetails.css';
import '../../../SweetAlert.css'

const line_separator = " / ";
const tab = "       ";


/*

SELECT	
  CAST (d.date AS DATE),
  count(*),
  minTime = MIN(d2.date),
  maxTime = MAX(d2.date)
  	
FROM
  [SDS_US_NorrisTexasUS].[dbo].[deployment] as d

  LEFT JOIN [SDS_US_NorrisTexasUS].[dbo].[deployment] AS d2
    ON d2.deployment_id = d.deployment_id

GROUP BY 
  CAST (d.date AS DATE)

ORDER BY CAST (d.date AS DATE);



-------------------

https://commerce.nearform.com/open-source/victory/docs/charts/candlestick
*/
const options = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};

const options2 = {
  hour: 'numeric',
  minute: '2-digit'
};

export default function StatisticsDetails({ showStatistics, setShowStatistics }) {
  const { t } = useTranslation();

  const [{ settings }, appDispatch] = useAppContext();
  const [statisticData, setStatisticData] = useState([]);
  // const [loaded, setLoaded] = useState(statisticData && statisticData.length > 0);

  const [label, setLabel] = useState(showStatistics.label);
  const [loading, setLoading] = useState(true);

  const [nearestValue, setNearestValue] = useState(false);
  const [nearestValue2, setNearestValue2] = useState(false);

  const [forceRefresh, setForceRefresh] = useState(false);
  const [savedPeriod, setSavedPeriod] = useState('6m');
  const [precise, setPrecise] = useState(savedPeriod.includes(','));
  const [periods, setPeriods] = useState([getPreciseTime(savedPeriod, 'start'), getPreciseTime(savedPeriod, 'end')]);

  const [lineData, setLineData] = useState([]);
  const [verticalBarData, setVerticalBarData] = useState([]);

  // console.log("106 - showStatistics=", showStatistics);

  function dateAddDays(a, b) {
    var d = new Date(b || new Date());
    d.setDate(d.getDate() + a);
    return d;
  }


  function getDates() {
    let start = getPreciseTime(savedPeriod, 'start');
    let end = getPreciseTime(savedPeriod, 'end');
    if (isNaN(start)) {
      start = 0;
    }
    if (isNaN(end)) {
      end = 0;
    }
    const startDate = new Date(new Date(+start).getTime() + Math.abs(new Date(+start).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
    const stopDate = new Date(new Date(+end).getTime() + Math.abs(new Date(+end).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);

    var dateArray = new Array();
    var currentDate = new Date(startDate);
    while (currentDate <= new Date(stopDate)) {

      if (currentDate) {
        const localLastTxt = new Date(currentDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options);

        dateArray.push(localLastTxt);
        currentDate = dateAddDays(1, currentDate)
      }
    }
    return dateArray;
  }


  const handleChangePeriod = (period, type = null) => {

    // setLoaded(false);
    setForceRefresh(true);

    // console.log('127 - handleChangePeriod=', period, type);

    if (type) { // user uses precise period
      const newPeriod = new Date(period).setHours(0, 0, 0, 0);
      const time = new Date(newPeriod).getTime();

      if (isNaN(time) || time <= 0)
        return;

      if (type === 'start') { // adjust new period accordingly if it is already manually set or not 
        period = [time, getPreciseTime(savedPeriod, 'end')];
      }
      else {
        period = [getPreciseTime(savedPeriod, 'start'), time];
      }
      setPeriods(period);

      // if (type === 'start') { // adjust new period accordingly if it is already manually set or not 
      //   period = [time, getPreciseTime(periods, 'end')];
      // }
      // else {
      //   period = [getPreciseTime(periods, 'start'), time];
      // }
      // setPeriod(undefined);
      // setPeriods(period);

    } else { // user uses a pre-defined time period     

      // console.log('155 - setSavedPeriod=', period);

      //changeSettings(t, 'period', period, settings, appDispatch);
      setSavedPeriod(period);
      setPeriods([getPreciseTime(period, 'start'), getPreciseTime(period, 'end')]);

      // setPeriod(period);
      // setPeriods([getPreciseTime(period, 'start'), getPreciseTime(period, 'end')]);
    }
  };

  useEffect(() => {
    // console.log('155 - savedPeriod=', savedPeriod);

    if (forceRefresh || (/*!loaded &&*/ statisticData.length === 0 && showStatistics.id)) {
      setForceRefresh(false);

      setLoading(true);
      setStatisticData([]);

      setLineData([]);
      setVerticalBarData([]);

      let start = getPreciseTime(savedPeriod, 'start');
      let end = getPreciseTime(savedPeriod, 'end');

      // console.log("170 - start=", start);
      // console.log("171 - end=", end);

      if (isNaN(start)) {
        start = 0;
      }
      if (isNaN(end)) {
        end = 0;
      }

      const startDate = new Date(new Date(+start).getTime() + Math.abs(new Date(+start).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);
      const endDate = new Date(new Date(+end).getTime() + Math.abs(new Date(+end).getTimezoneOffset() * 60000)).toJSON().slice(0, 10);

      // console.log("183 - startDate=", startDate);
      // console.log("184 - endDate=", endDate);

      getLocationStatistics({ id: showStatistics.id, startDate, endDate }).then(res => {
        setLoading(false);
        if (!res.success) {
          toast(decodeHTMLEntities(t('statistics.errors.' + res)), { type: 'error' });

        } else {

          if (res && res.selected && res.selected[0] && res.selected[0].statisticsList) {
            // console.log("205 - res.selected[0].statisticsList=", res.selected[0].statisticsList.length)
            setStatisticData(res.selected[0].statisticsList);

            const allDates = getDates();
            const data = [];
            const data2 = [];

            const mapStats = new Map();
            for (const stat of res.selected[0].statisticsList) {
              const localLastTxt = new Date(stat.date).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
              mapStats.set(localLastTxt, stat);
            }

            let i = 0;
            const mapDate = new Map();
            const mapHeures = new Map();

            for (const date of allDates) {
              const elt = {
                x: i,
                y: mapStats.get(date) ? mapStats.get(date).countDeployment : 0,
                date: date
              }
              mapDate.set(date, elt);

              let y = 24;
              let h, m, h0, m0;
              let y0 = 24;
              if (mapStats.get(date)) {
                h = parseInt(("" + (mapStats.get(date).maxDate)).substring(11, 13));
                m = parseInt(("" + (mapStats.get(date).maxDate)).substring(14, 16));
                y = Math.round((((h * 60 + m) / 60) + Number.EPSILON) * 100) / 100;

                h0 = parseInt(("" + (mapStats.get(date).minDate)).substring(11, 13));
                m0 = parseInt(("" + (mapStats.get(date).minDate)).substring(14, 16));
                y0 = Math.round((((h0 * 60 + m0) / 60) + Number.EPSILON) * 100) / 100;
              }

              const jour = {
                x: date,
                y: y,
                h: h,
                m: m,
                y0: y0,
                h0: h0,
                m0: m0,
                date: date
              }
              mapHeures.set(date, jour);
              i++;
            }

            if (mapDate.size > 0) {
              for (const value of Array.from(mapDate.values())) {
                data.push(value);
              }
            }
            setLineData(data);

            if (mapHeures.size > 0) {
              for (const value of Array.from(mapHeures.values())) {
                data2.push(value);
              }
            }
            // console.log("288 - mapHeures=", mapHeures);
            setVerticalBarData(data2);
          }
        }
      });
    }
  }, [t, showStatistics, savedPeriod, setStatisticData]);


  return (
    <div>
      <Prompt animated style={{ /*zIndex: 10000 /* Above tooltip which has 9999 */ }}>
        <div className="prompt__container animated"
          style={{
            height: "99999px", maxHeight: "90%",
            width: "99999px", maxWidth: "90%",
          }}>

          <PromptWrapper >
            <div className="statisticsDetails_settings">
              <div className="MuiDataGrid-root" role="grid" aria-colcount={0} aria-rowcount={0}>

                <div className="content__header">
                  <h2>{(t('statistics.title'))}{'\u2000\u2013\u2000'}
                    <span style={{ color: colors.softthinks }}>
                      {label}
                    </span>
                  </h2>
                </div>

                <div className="MuiDataGrid-main">
                  <div style={{ display: 'flex', width: '90%', justifyContent: 'center' }}>

                    <div className="periodSelect" style={{ marginBottom: '10px', width: '30%', justifyContent: 'left' }}>
                      <p>{t('sidebar.filters.period.title')}</p>
                      <span
                        className="material-icons-round"
                        onClick={() => setPrecise(!precise)}
                        style={precise ? { color: colors.softthinks } : {}}
                      >
                        tune
                      </span>
                    </div>

                    {precise ? (
                      <>
                        <div className="periodSelect" style={{ marginBottom: '10px', width: '30%', justifyContent: 'left' }}>
                          <p>{t('sidebar.filters.period.start')}</p>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker disabled={false} value={periods[0]}
                              onChange={date => handleChangePeriod(date, 'start')}
                              onBlur={() => setSavedPeriod(periods.join(','))}
                              // changeSettings(t, 'period', periods.join(','), settings, appDispatch)}
                              onClose={() => setSavedPeriod(periods.join(','))}
                              // changeSettings(t, 'period', periods.join(','), settings, appDispatch)}

                              format={localStorage.getItem('lang') === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'}
                              placeholder={localStorage.getItem('lang') === 'fr' ? 'jj/mm/aaaa' : 'mm/dd/yyyy'}

                              disableToolbar variant="inline" inputVariant="outlined" InputAdornmentProps={{ position: 'start' }}
                            />
                          </MuiPickersUtilsProvider>
                        </div>

                        <div className="periodSelect" style={{ marginBottom: '10px', width: '30%', justifyContent: 'left' }}>
                          <p>{t('sidebar.filters.period.end')}</p>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker disabled={false} value={periods[1]}
                              onChange={date => handleChangePeriod(date, 'end')}
                              onBlur={() => setSavedPeriod(periods.join(','))}
                              // changeSettings(t, 'period', periods.join(','), settings, appDispatch)}
                              onClose={() => setSavedPeriod(periods.join(','))}
                              // changeSettings(t, 'period', periods.join(','), settings, appDispatch)}

                              format={localStorage.getItem('lang') === 'fr' ? 'dd/MM/yyyy' : 'MM/dd/yyyy'}
                              placeholder={localStorage.getItem('lang') === 'fr' ? 'jj/mm/aaaa' : 'mm/dd/yyyy'}

                              disableToolbar variant="inline" inputVariant="outlined" InputAdornmentProps={{ position: 'start' }}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                      </>
                    ) : (
                      <div style={{ marginBottom: '10px', width: '60%', justifyContent: 'left' }}>
                        <PeriodSelect
                          defaultValue={savedPeriod.includes(',') ? 'choose' : savedPeriod}
                          // setSavedPeriod={setSavedPeriod}
                          onChangePeriod={period => handleChangePeriod(period)}
                        />
                      </div>
                    )}
                  </div>

                  {statisticData.length > 0 ? ( // a.private = (false || true), global scenarios are first in alphabetical order
                    <div>
                      <div style={{ height: "50%" }}>
                        <FlexibleWidthXYPlot
                          height={350}
                          xDistance={10}
                          margin={{ left: 100, bottom: 70, right: 50 }}
                          onMouseLeave={() => setNearestValue(false)}
                        >
                          <VerticalGridLines />
                          <HorizontalGridLines />

                          <XAxis
                            tickLabelAngle={-15}
                            tickFormat={function tickFormat(d) {
                              return lineData[d] && lineData[d].date;
                            }}
                          />
                          <YAxis />

                          <LineSeries
                            // curve={'curveBumpX'}
                            data={lineData}
                            color={colors.softthinks}
                            onNearestX={(value, { event, innerX, index }) => {
                              setNearestValue(value);
                            }}
                          />

                          {nearestValue &&
                            <Crosshair values={[nearestValue]}>

                              <div style={{
                                margin: "10px -50px",
                                padding: "10px 20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                backgroundColor: "white",
                                borderRadius: "var(--radius-medium)",
                                border: "1px solid black",
                                boxShadow: "10px 10px 6px 1px #3030309E",
                                fontSize: "150%"
                              }}>

                                <div style={{ color: colors.softthinks }}>
                                  {t('statistics.date')} : {nearestValue.date}
                                </div>
                                {tab}/{tab}
                                <div style={{ color: colors.softthinks }}>
                                  {t('statistics.count')} : {nearestValue.y}
                                </div>
                              </div>
                            </Crosshair>
                          }

                        </FlexibleWidthXYPlot>
                      </div>

                      <div style={{ height: "50%" }}>
                        <FlexibleWidthXYPlot
                          height={320}
                          margin={{ left: 100, top: 20, right: 50 }}
                          // onMouseLeave={() => console.log("297")}
                          xType="ordinal"
                          onMouseLeave={() => setNearestValue2(false)}
                        >
                          <VerticalGridLines />
                          <HorizontalGridLines
                            tickValues={[0, 6, 12, 18, 24]}
                          />
                          <YAxis
                            tickValues={[0, 6, 12, 18, 24]}
                          />

                          <VerticalBarSeries
                            stroke={colors.softthinks + "C0"}
                            color={colors.softthinks}
                            data={verticalBarData}
                            onNearestX={(value, { event, innerX, index }) => {
                              setNearestValue2(value);
                            }}
                          />

                          {nearestValue2 &&
                            <Crosshair
                              values={[nearestValue2]}
                            >

                              <div style={{
                                margin: "10px -50px",
                                padding: "10px 20px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                backgroundColor: "white",
                                borderRadius: "var(--radius-medium)",
                                border: "1px solid black",
                                boxShadow: "10px 10px 6px 1px #3030309E",
                                fontSize: "150%"
                              }}>

                                <div style={{ color: colors.softthinks }}>
                                  {t('statistics.date')} : {nearestValue2.date}
                                </div>

                                {(nearestValue2.h0 || nearestValue2.h) &&
                                  <>
                                    {tab}/{tab}
                                    <div style={{ color: colors.softthinks }}>
                                      {t('statistics.start')} : {nearestValue2.h0}h{('0' + nearestValue2.m0).slice(-2)}
                                    </div>
                                    {tab}/{tab}
                                    <div style={{ color: colors.softthinks }}>
                                      {t('statistics.end')} : {nearestValue2.h}h{('0' + nearestValue2.m).slice(-2)}
                                    </div>
                                  </>
                                }
                              </div>
                            </Crosshair>
                          }

                        </FlexibleWidthXYPlot>
                      </div>

                    </div>
                  ) : ( // Scenarios are empty or no location is selected
                    <div className="loader">
                      {!loading ? <h2>{t('reporting.no_data')}.</h2> : <BeatLoader color={colors.softthinks} />}
                    </div>
                  )}

                </div>
              </div>
            </div>
          </PromptWrapper >

          <PromptActions column>
            <Button className="btnSecondary" style={{ margin: '1px auto', width: '50%' }} onClick={() => setShowStatistics(null)}>
              {t('global.close')}
            </Button>
          </PromptActions>
        </div >
      </Prompt >
    </div >
  );
}
